// 全局配置文件
// ============================================
// 手动切换环境方式（最简单）：
// ============================================
// 方式1: 直接修改下面的 USE_PRODUCTION 变量
//   - true = 使用生产环境 (https://shengjuhulian.cn)
//   - false = 使用开发环境 (http://127.0.0.1:4000)
// 
// ⚠️ 重要提示：修改后需要重启以下服务才能生效：
//   1. Vue 开发服务器（npm run serve）- 按 Ctrl+C 停止后重新启动
//   2. Electron 应用（如果正在运行）- 完全关闭后重新启动
//   3. 如果使用生产构建，需要重新构建（npm run build）
// 
// 📌 此配置会影响：
//   - 所有 API 请求地址
//   - QQ 登录回调地址
//   - 软件更新检查地址（electron/updater.js）
//   - 软件更新下载地址
const USE_PRODUCTION = true;//换：true=生产环境，false=开发环境

// ============================================
// 自动切换环境方式（通过环境变量）：
// ============================================
// 方式2: 使用环境变量（优先级高于手动设置）
//   - NODE_ENV=production 或 API_ENV=production 时使用生产环境
//   - 或直接设置 API_URL 环境变量指定地址
const isProduction = process.env.NODE_ENV === 'production' || process.env.API_ENV === 'production';

// 配置优先级：环境变量 API_URL > 环境变量 NODE_ENV/API_ENV > 手动设置 USE_PRODUCTION
const API_URL = process.env.API_URL || (isProduction || USE_PRODUCTION
  ? 'https://shengjuhulian.cn' 
  : 'http://127.0.0.1:4000');

/**
 * 音频上传：API 为本地（127.0.0.1 / localhost）时走服务端 multipart /api/audio/upload，不请求 OSS；
 * 指向线上域名时走 OSS 预签名链路。可用 VUE_APP_AUDIO_UPLOAD_OSS=true|false 覆盖。
 */
function isLocalDevelopmentApiUrl (url) {
  const u = String(url || '')
    .trim()
    .replace(/\/$/, '')
  return /^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(u)
}
const AUDIO_UPLOAD_USE_OSS =
  process.env.VUE_APP_AUDIO_UPLOAD_OSS === '0' ||
  process.env.VUE_APP_AUDIO_UPLOAD_OSS === 'false'
    ? false
    : process.env.VUE_APP_AUDIO_UPLOAD_OSS === '1' ||
        process.env.VUE_APP_AUDIO_UPLOAD_OSS === 'true'
      ? true
      : !isLocalDevelopmentApiUrl(API_URL)

const SHOW_NAVIGATION = false; // true=显示导航页，false=直接进dashboard

// 开发环境（npm run serve）：是否在 8080 的 webpack-dev-server 上代理 /api、/auth 等到 API_URL。
// false = 浏览器直连 config 里的 API_URL（如 http://127.0.0.1:4000），Network 里不再出现 8080 代理接口；后端须配置 CORS 允许前端源（如 http://127.0.0.1:8080）。
// true = 保持原有代理，适合后端未开 CORS 时。
const USE_DEV_SERVER_API_PROXY = false

/**
 * 是否启用声展云端资料同步（GET/PUT /api/voice-showcase/profile 及分情绪上传等）。
 * 为 false 时仅使用本机 localStorage + IndexedDB，不请求云端 profile。
 * 默认 true：登录后会尝试拉取云端；接口 404/501 时静默回退本机。
 * 纯本地开发可设 VUE_APP_VOICE_SHOWCASE_CLOUD=false
 */
const VOICE_SHOWCASE_CLOUD =
  process.env.VUE_APP_VOICE_SHOWCASE_CLOUD === '0' ||
  process.env.VUE_APP_VOICE_SHOWCASE_CLOUD === 'false'
    ? false
    : true

// 运行时配置（开发环境热生效）：
// npm run serve 启动的 dev server 会在每次请求时重新读取本文件（含环境变量），
// 并通过 /__config.js 注入到 window.__APP_CONFIG__。浏览器端加载本模块时，
// 若存在 window.__APP_CONFIG__ 则优先使用它覆盖下方编译时的默认值。
// 因此开发环境修改本文件或切换环境变量后，只需刷新浏览器即可生效，无需重启 dev server。
// 生产构建 / Electron 主进程没有 window.__APP_CONFIG__，回退使用编译时值。
const runtimeConfig =
  typeof window !== 'undefined' &&
  window.__APP_CONFIG__ &&
  typeof window.__APP_CONFIG__ === 'object'
    ? window.__APP_CONFIG__
    : null

// 导出配置
module.exports = {
  API_URL,
  SHOW_NAVIGATION,
  USE_DEV_SERVER_API_PROXY,
  AUDIO_UPLOAD_USE_OSS,
  VOICE_SHOWCASE_CLOUD,
  ...(runtimeConfig || {})
}

